<div class="p-3 form-container">
    <div class=" border rounded shadow-sm">
    <form [formGroup]="fileUploadForm" (ngSubmit)="onSubmit()" class="d-flex align-items-center justify-content-between">
        <div class="col-lg-3 mt-4 ">
            <mat-form-field appearance="outline" >
                <mat-label>Choose an option</mat-label>
                <mat-select formControlName="selectedOption" class="text-sm" >
                    <mat-option value="file1">BMW</mat-option>
                    <mat-option value="file2">Trimble</mat-option>
                    <mat-option value="file3">Mbenz</mat-option>
                </mat-select>
                <mat-error *ngIf="fileUploadForm.get('selectedOption')?.hasError('required')">
                    You must select an option.
                </mat-error>
            </mat-form-field></div>
        <div class="col-lg-3">
            <button mat-raised-button *ngIf="!selectedFile" color="primary" (click)="fileInput.click()">Upload</button>
            <input type="file" #fileInput style="display: none" (change)="onFileChange($event)" />
            <div *ngIf="selectedFile" class="file-info">
                <span>{{ selectedFile.name }}</span>
                <button mat-icon-button color="warn" (click)="cancelFile()">
                    <mat-icon>cancel</mat-icon>
                </button>
            </div>
        </div>
        <div class="col-lg-3"> <button mat-raised-button color="accent" type="submit"
                [disabled]="!fileUploadForm.valid" >Submit</button></div>
    </form>
    </div>
</div>